module.exports = __webpack_public_path__ + "media/images/iconClipboard-a6979e5b4e3bc603ad979cc18a4707ab.png";